import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Webform,
} from '@uncinc/react-drupal-core';

import {
  WebformSearch,
} from '../../../components';

import './style.scss';

const ParagraphWebform = ({ entity }) => {
  const id = entity.getIn(['field_webform', 0, 'target_id']);
  const status = entity.getIn(['field_webform', 0, 'status']);

  const overriddenComponents = {
    search: WebformSearch,
  };

  const pushEventOnSubmit = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submitted',
      formId: id,
    });
  };

  return (
    <Container className="ParagraphWebform">
      <div className="row">
        <div className="ParagraphWebform__inner col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <Webform
            root
            id={id}
            onSuccessfullSubmit={pushEventOnSubmit}
            overriddenComponents={overriddenComponents}
            status={status}
            onlySubmitVisibleFields
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphWebform;
